import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Cropper from 'react-cropper';
import Dropzone from 'react-dropzone';
import fileSizeLessThan from '../utils/fileSizeLessThan';
import fileType from '../utils/fileType';
import Icon from '../icons/Icon';
import CropperScaffold from './CropperScaffold';

class ImageCropper extends Component {
  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    required: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    required: true,
  };

  state = {
    imageError: null,
  };

  onImageCrop = () => {
    if (typeof this.cropperRef.getCroppedCanvas() !== 'undefined') {
      this.props.input.onChange({
        ...this.props.input.value,
        imageResult: this.cropperRef.getCroppedCanvas().toDataURL(),
      });
    }
  };

  onImageUpload = files => {
    const fileSizeValidation = fileSizeLessThan(3145728)(files);
    const fileTypeValidation = fileType(['image/jpg', 'image/jpeg', 'image/png'], 'File must be a jpg or png image')(
      files
    );

    if (fileSizeValidation.isValid && fileTypeValidation.isValid) {
      const reader = new FileReader();
      reader.onload = () => {
        this.props.input.onChange({
          imageSrc: reader.result,
          imageFilename: files[0].name,
          imageResult: reader.result,
        });
        this.setState({
          imageError: null,
        });
      };
      reader.readAsDataURL(files[0]);
    } else {
      if (!fileTypeValidation.isValid) {
        this.setState({
          imageError: fileTypeValidation.message,
        });
      } else if (!fileSizeValidation.isValid) {
        this.setState({
          imageError: fileSizeValidation.message,
        });
      }
    }
  };

  render() {
    const { input: { value, onChange }, label, meta: { touched, error }, required } = this.props;

    const imageCropper = {
      'image-cropper': true,
      [`${this.props.className}`]: this.props.className,
    };

    return (
      <CropperScaffold label={label} validation={this.state.imageError} required={required}>
        <div>
          <div className={classNames(imageCropper)}>
            {value && value.imageSrc ? (
              <Cropper
                ref={input => {
                  this.cropperRef = input;
                }}
                src={value.imageSrc}
                style={{ height: 200, width: '100%' }}
                // Cropper.js options
                guides
                viewMode={1}
                autoCropArea={1}
                cropend={this.onImageCrop}
              />
            ) : (
              <Dropzone className="dropzone" activeClassName="dropzone--active" onDrop={this.onImageUpload}>
                <div className="dropzone__info">
                  <Icon icon="ImageUpload" />
                  <h4>Drag image here or browse</h4>
                  <p>Accepted file types: .jpg, .jpeg, .png</p>
                  <p>Max file size: 3MB</p>
                </div>
              </Dropzone>
            )}
          </div>
          {touched && error ? <div className="input-validation">{error}</div> : null}
          {value ? (
            <div className="cropper-scaffold__controls">
              <button type="button" className="button button--theme--secondary" onClick={e => onChange(null)}>
                Remove {label}
              </button>
            </div>
          ) : null}
        </div>
      </CropperScaffold>
    );
  }
}

export default ImageCropper;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormsImageCropper.js